import { render, staticRenderFns } from "./BlockPropertiesPanel.vue?vue&type=template&id=d6ec114c&scoped=true&"
import script from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./BlockPropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlockPropertiesPanel.vue?vue&type=style&index=0&id=d6ec114c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec114c",
  null
  
)

export default component.exports